import { ITimeoffRequestDocument, IDate, EDayOfWeek } from "../models"
import * as timeHelper from "./timeHelper"
import moment from "moment"
import { EnumValues } from "enum-values"
import strings from "../localization/strings"

export function checkDateTimeLocalValid(timeoff: ITimeoffRequestDocument, targetDateTime: IDate): boolean {
    const targetTimeoffStartDate = timeHelper.keepConvertUTCToLocal(timeoff.StartDate)
    const targetTimeoffEndDate = timeHelper.keepConvertUTCToLocal(timeoff.EndDate)

    let valid = moment(targetTimeoffStartDate).isSameOrBefore(targetDateTime) && moment(targetDateTime).isSameOrBefore(targetTimeoffEndDate)
    if (valid && timeoff.SpecifyDays && timeoff.SpecifyDays.length > 0) {
        valid = timeoff.SpecifyDays.includes(moment(targetDateTime).weekday())
    }
    return valid
}

export function getTimeoffDateStr(timeoff: ITimeoffRequestDocument): string {
    const targetTimeoffStartDate = timeHelper.keepConvertUTCToLocal(timeoff.StartDate)
    const targetTimeoffEndDate = timeHelper.keepConvertUTCToLocal(timeoff.EndDate)
    let timeoffDateStr = moment(targetTimeoffStartDate).isSame(targetTimeoffEndDate, "day") ?
        moment(targetTimeoffStartDate).format("MM/DD/YYYY") :
        `${moment(targetTimeoffStartDate).format("MM/DD/YYYY")} - 
        ${moment(targetTimeoffEndDate).format("MM/DD/YYYY")}`
    if (timeoff.SpecifyDays && timeoff.SpecifyDays.length > 0) {
        const specifyDays = timeoff.SpecifyDays
            .sort((a, b) => a - b)
            .map(day => strings[`${EnumValues.getNameFromValue(EDayOfWeek, day)}_ShortTerm`])
        const daysString = specifyDays.join(", ")
        timeoffDateStr += `, Specify Days: ${daysString}`
    }
    return timeoffDateStr
}